import { ServiceApi } from '../../utils/auth'

const state = {
    visits: [],
    loading: false,
    error: null,
}

const actions = {
    // LIST COMPANY
    async getVisitsToCompany({ commit }, { company_id, filter }) {
        commit('transactionBegin')
        try {
            const resp = await ServiceApi.get(`api/get-visits/${company_id}`, filter);
            commit('transactionSuccess', true)
            commit("SET_VISIT_COMPANY", resp.data);
            return resp.data;
        } catch (error) {
            commit('transactionErr', error)
            return error
        }
    },
    async processPayments({ commit }, payload) {
        commit('transactionBegin')
        try {
            const resp = await ServiceApi.post("/api/manage-payment-visit-request", payload);
            commit('transactionSuccess', true)
            return resp.data;
        } catch (error) {
            commit('transactionErr', error)
            return error
        }
    },
    async processVisits({ commit }, payload) {
        commit('transactionBegin')
        console.log(payload)
        try {
            const resp = await ServiceApi.post("/api/manage-visit", payload);
            commit('transactionSuccess', true)
            return resp.data;
        } catch (error) {
            commit('transactionErr', error)
            return error
        }
    },
}

const getters = {
    getVisits: state => state.visits,
    visitsLoading: (state) => state.loading,
}

const mutations = {
    SET_VISIT_COMPANY(state, payload) {
        state.visits = payload.data
    },
    transactionBegin(state) {
        state.loading = true
    },
    transactionSuccess(state) {
        state.loading = false
    },
    transactionErr(state, err) {
        state.loading = false
        state.error = err
    },
}

export default {
    namespaced: false,
    state,
    actions,
    mutations,
    getters
}
